import { render } from "./TripStatusLabel.vue?vue&type=template&id=33d0f81a&scoped=true"
import script from "./TripStatusLabel.vue?vue&type=script&lang=js"
export * from "./TripStatusLabel.vue?vue&type=script&lang=js"

import "./TripStatusLabel.vue?vue&type=style&index=0&id=33d0f81a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d0f81a"]])

export default __exports__